import {REJECTED_QC_FOR_PO_LOADED} from "./ActionType";

export default function rejectedQCForPOReducer(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case REJECTED_QC_FOR_PO_LOADED:
      return (state = payload);

    default:
      return state;
  }
}
